import get from 'lodash/get';

export const oneMoment = () => new Promise(resolve => {
  setTimeout(() => resolve(0), 1000);
});

export const getFieldFromPath = (obj, path, isNullValue) => {
  return get(obj, path, isNullValue);
};
